import { mixpanelObject } from 'src/utils/analytics';
import { clearCtaEventsProperty } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { DynamicObject } from 'src/utils/commonTypes';
import {
  ARTICLES_NEWS_URL,
  ZEEKANNADA_NEWS_URL
} from 'src/utils/constants/ApiConstants';
import {
  CountryCode,
  HeaderElements,
  NavMenuElements
} from 'src/utils/constants/stringConstants';

import {
  ctaEvent,
  timeEvent
} from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { globalUrlHelper } from '../../utils/common';
import { NavMenuLinks } from '../../utils/constants/RouterConstants';
import {
  MIXPANEL_TYPE,
  MIXPANEL_ELEMENT,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_HEADER,
  MIXPANEL_HORIZONTAL_INDEX
} from '../../utils/analytics/mixpanel/mixpanelConstants';

type HeaderType = {
  link: string;
  element: string;
  elementName: string;
};

type DataItemsType = {
  [key: string]: HeaderType;
};

export const getMenuDetails = (
  menuItems: Array<string>,
  headerStrings: DynamicObject
) => {
  const menuDetails = [];
  const NavMenuItemList: DataItemsType = {
    home: {
      link: NavMenuLinks.HOME,
      element: headerStrings.MENU_HOME,
      elementName: NavMenuElements.HOME
    },
    plex: {
      link: NavMenuLinks.PLEX,
      element: headerStrings.MENU_NAV_PLEX,
      elementName: NavMenuElements.RENT
    },
    premium: {
      link: NavMenuLinks.PREMIUM,
      element: headerStrings.MENU_PREMIUM,
      elementName: NavMenuElements.PREMIUM
    },
    freemovies: {
      link: NavMenuLinks.FREE_MOVIES,
      element: headerStrings.MENU_FREEMOVIES,
      elementName: NavMenuElements.FREEMOVIES
    },
    tvshows: {
      link: NavMenuLinks.TV_SHOWS,
      element: headerStrings.MENU_TVSHOWS,
      elementName: NavMenuElements.TVSHOWS
    },
    movies: {
      link: NavMenuLinks.MOVIES,
      element: headerStrings.MENU_MOVIES,
      elementName: NavMenuElements.MOVIES
    },
    sports: {
      link: NavMenuLinks.GAME_ROUTE,
      element: headerStrings.MENU_SPORTS,
      elementName: NavMenuElements.SPORTS
    },
    learning: {
      link: NavMenuLinks.LEARNING,
      element: headerStrings.MENU_EDUAURAA,
      elementName: NavMenuElements.EDUAURAA
    },
    kids: {
      link: NavMenuLinks.KIDS,
      element: headerStrings.MENU_KIDS,
      elementName: NavMenuElements.KIDS
    },
    music: {
      link: NavMenuLinks.MUSIC,
      element: headerStrings.MENU_MUSIC,
      elementName: NavMenuElements.MUSIC
    },
    livetv: {
      link: NavMenuLinks.LIVE_TV,
      element: headerStrings.MENU_LIVE,
      elementName: NavMenuElements.LIVE
    },
    videos: {
      link: NavMenuLinks.VIDEOS,
      element: headerStrings.MENU_VIDEOS,
      elementName: NavMenuElements.VIDEOS
    },
    news: {
      link: NavMenuLinks.NEWS,
      element: headerStrings.MENU_NEWS,
      elementName: NavMenuElements.NEWS
    },
    originals: {
      link: NavMenuLinks.WEBSERIES,
      element: headerStrings.WEBSERIES,
      elementName: NavMenuElements.ZEEORIGINALS
    },
    upcoming: {
      link: NavMenuLinks.UPCOMING,
      element: headerStrings.MENU_NAV_UPCOMING,
      elementName: NavMenuElements.NAV_UPCOMING
    },
    'tv-channels': {
      link: NavMenuLinks.TV_CHANNELS,
      element: headerStrings.MENU_CHANNELS,
      elementName: NavMenuElements.CHANNELS
    }
  };
  for (let i = 0; i < Object.keys(menuItems).length; i += 1) {
    if (NavMenuItemList[menuItems[i]]) {
      menuDetails.push(NavMenuItemList[menuItems[i]]);
    }
  }
  return menuDetails;
};

export const anchorTagUrlGenerator = (link: string) => {
  let anchorUrl = link;
  if (link === NavMenuLinks.STORIES) {
    anchorUrl = ZEEKANNADA_NEWS_URL;
  } else if (link === NavMenuLinks.ARTICLES) {
    anchorUrl = ARTICLES_NEWS_URL;
  }
  return globalUrlHelper(anchorUrl);
};

/**
 * This function will check which Nav menu item is active and return boolean
 * based on that
 * @param dataLink : This is url from router.asPath()
 * @param urlPath : This is the NavMenuLinks (/movies, /originals, /web-series)
 * @returns : Boolean flag based on router path and nav menu links match.
 */
export const getActiveMenuItem = (dataLink: string, urlPath: string) => {
  let path = '';
  if (urlPath.includes(CountryCode.GLOBAL)) {
    if (urlPath.includes('add-ons')) {
      // '/global/add-ons/simply-south/movies' we are extracting movies from this url
      path = urlPath?.split('/')[4]?.toLowerCase();
    } else {
      // '/global/movies/details' we are extracting movies from this url
      path = urlPath?.split('/')[2]?.toLowerCase();
    }
  } else {
    // '/movies/details' same as above extracting movies
    path = urlPath?.split('/')[1]?.toLowerCase();
  }
  const bucket = dataLink && dataLink.split('/')[1];

  let flag = false;
  if (
    bucket === HeaderElements.TV_SHOW &&
    path?.includes(HeaderElements.TV_SHOW)
  ) {
    if (
      dataLink === NavMenuLinks.TV_CHANNELS &&
      urlPath.includes(HeaderElements.TV_CHANNEL)
    ) {
      flag = true;
    } else if (
      dataLink !== NavMenuLinks.TV_CHANNELS &&
      !urlPath.includes(HeaderElements.TV_CHANNEL)
    ) {
      flag = true;
    }
  } else if (path === bucket) {
    flag = true;
  }
  return flag;
};

export const removeTelcoUserMenuList = [
  '/live-tv',
  '/eduauraa',
  '/news',
  '/zee-plex-movies-on-rent',
  '/tv-shows/tv-channels',
  '/music-videos',
  '/logout'
];

export const navMenuMixpanelEvent = (
  element: string,
  elementName: string,
  index: number
) => {
  // mixpanel Initailization start
  clearCtaEventsProperty(mixpanelObject);
  mixpanelObject.setProperty(MIXPANEL_TYPE, elementName);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, element);

  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_HEADER);
  mixpanelObject.setProperty(MIXPANEL_HORIZONTAL_INDEX, index);
  ctaEvent();
  timeEvent();
  // mixpanel Initailization end
};
